import { ApiClient } from '@dozuki/web-js/utils';

// "Common Request Options" can be provided anywhere a request-maker is invoked
export type CommonRequestOptions = {
   apiClient?: ApiClient;
   onUploadProgress?: (progressEvent: any) => void;
};

// "Private Request Options" can be provided by a request-maker directly,
//  but not where a request-maker is invoked, unless explicitly exposed
//  by the request-maker
type PrivateRequestOptions = {
   query?: any;
   body?: any;
   headers?: Record<string, string>;
};

type RequestOptions = CommonRequestOptions & PrivateRequestOptions;

type APIMethod = 'get' | 'post' | 'patch' | 'put' | 'delete';

const isServerSide = typeof window === 'undefined';

export async function makeRequest(
   method: APIMethod,
   endpoint: string,
   options: RequestOptions = {}
) {
   if (!options.apiClient && isServerSide) {
      throw Error(`'apiClient' must be provided when calling API request-makers server-side.`);
   }

   const apiClient = options.apiClient || new ApiClient();

   const response = await apiClient.request(method, endpoint, {
      params: options.query,
      data: options.body,
      onUploadProgress: options.onUploadProgress,
      headers: options.headers,
   });

   return response.data;
}
